import { render, staticRenderFns } from "./StoreButton.vue?vue&type=template&id=160f6c16"
import script from "./StoreButton.vue?vue&type=script&lang=js"
export * from "./StoreButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports